import apiHandler from "../core/apiHandler";

const brandApi = apiHandler("brands");

export default brandApi;